// extracted by mini-css-extract-plugin
module.exports = {"container":"blocks_container__3jGEj","titleContainer":"blocks_titleContainer__2KE9c","iconDrag":"blocks_iconDrag__3h188","loader":"blocks_loader__Hf5_v"};